import clsx from 'clsx'
import { useId } from 'react'

type Props = {
  'aria-label'?: string
  'label'?: string
  'className'?: string
  'placeholder'?: string
  'value'?: string
  'readOnly'?: boolean
  'onChange'?: (v: string) => void
}
export function TextArea({
  className,
  label,
  placeholder,
  value,
  readOnly,
  onChange,
  'aria-label': ariaLabel
}: Props) {
  const id = useId()
  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label htmlFor={id} className="block text-gray-900">
          {label}
        </label>
      )}
      <textarea
        id={id}
        aria-label={ariaLabel}
        rows={4}
        placeholder={placeholder}
        readOnly={readOnly}
        className={clsx(
          'block resize-none rounded-md border-0 px-2 py-3 leading-5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 read-only:bg-gray-50 read-only:text-gray-600 focus:ring-2 focus:ring-inset focus:ring-indigo-600 read-only:focus:ring-gray-300',
          className
        )}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      />
    </div>
  )
}
